import Compressor from 'compressorjs'
// https://github.com/fengyuanchen/compressorjs

// tipos que el navegador puede recomprimir; el resto (tiff, raw) se sube sin cambios
const TIPOS_COMPRIMIBLES = ['image/jpeg', 'image/png']

// primera pasada, siempre: mantiene la resolución y casi no pierde calidad.
// 4096 px es el lado máximo seguro para el canvas en celulares (en iOS un canvas más grande sale en blanco),
// y solo achica fotos de más de ~16 MP
const PASADA_INICIAL = { maxLado: 4096, calidad: 0.92 }

// pasadas más bruscas, de menor a mayor pérdida, solo si después de la inicial sigue superando maxBytes;
// se corta en la primera que queda dentro del máximo
const PASADAS_EXTRA = [
  { maxLado: 4096, calidad: 0.8 },
  { maxLado: 3072, calidad: 0.75 },
  { maxLado: 2048, calidad: 0.7 }
]

// recomprime fotos de cámara antes de subirlas; ante cualquier error devuelve el archivo original
// devuelve siempre el resultado más liviano entre el original y las pasadas hechas
export async function comprimirImagen(file, { maxBytes } = {}) {
  if (!file || !TIPOS_COMPRIMIBLES.includes(file.type))
    return file

  let mejor = await masLiviano(file, file, PASADA_INICIAL)

  for (const pasada of PASADAS_EXTRA) {
    if (!maxBytes || mejor.size <= maxBytes)
      break
    mejor = await masLiviano(file, mejor, pasada)
  }

  return mejor
}

// comprime siempre a partir del original (no recomprime un resultado ya comprimido) y se queda con el más liviano
async function masLiviano(original, mejor, pasada) {
  const resultado = await comprimir(original, pasada)
  return resultado.size < mejor.size ? resultado : mejor
}

function comprimir(file, { maxLado, calidad }) {
  return new Promise((resolve) => {
    new Compressor(file, {
      maxWidth: maxLado,
      maxHeight: maxLado,
      quality: calidad,
      // no convierto PNG a JPEG: el nombre y la extensión que espera Garantías no cambian
      convertSize: Infinity,
      success: (result) => resolve(new File([result], file.name, { type: result.type, lastModified: file.lastModified })),
      error: () => resolve(file)
    })
  })
}
